
// eslint-disable-next-line import/prefer-default-export
export const authTokenSelector = (state) => state?.auth?.authToken
export const sessionSelector = (state) =>  state?.auth?.isLogout